var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"auto","content-class":"elevation-0 overflow-hidden"},model:{value:(_vm.inProgress),callback:function ($$v) {_vm.inProgress=$$v},expression:"inProgress"}},[_c('v-progress-circular',{staticClass:"mb-2 justify-center",attrs:{"indeterminate":"","color":"white","size":70,"width":7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }